import React, { memo } from "react";
import SurfacesPreview from "./components/previews/SurfacesPreview";
import SurfaceOrchestrator from "./components/SurfaceOrchestrator";
import Widget from "./components/Widget";
import { VIEWS } from "./conf";
import useData from "./hooks/useData";

const BaseApp = memo(() => {
	const { view } = useData();

	// ADDING TEMP CONDITION FOR view === 'LEAD_GEN' to support old script cache
	return (
		<>
			{view === VIEWS.ALL ? (
				<>
					<Widget />
					<SurfaceOrchestrator />
				</>
			) : view === VIEWS.SURFACE ? (
				<SurfacesPreview />
			) : view === VIEWS.OVERLAY ? (
				<SurfaceOrchestrator />
			) : view === VIEWS.WIDGET || view === "LEAD_GEN" ? (
				<Widget />
			) : null}
		</>
	);
});

export default BaseApp;
